import { useIdleTimer } from 'react-idle-timer';
import { GetApplicationSetting, IApplicationSettings } from '../../assets/configuration';
import { useCallback, useEffect } from 'react';
//add import for context to use for timeout timer

type UseCustomIdleTimerArgs = {
    enabled: boolean | {};
};

const settings: IApplicationSettings = GetApplicationSetting;
const timeoutMs = settings.authSettings.sessionTimeoutIntervalInMilliseconds;
const useCustomIdleTimer = ({ enabled }: UseCustomIdleTimerArgs) => {

    const onIdle = useCallback(() => {
        window.location.assign(`${window.location.origin}/logout`);
    }, []);

    const { reset } = useIdleTimer({
        timeout: timeoutMs,
        onIdle,
        events: ["mousedown", "touchstart"],
        stopOnIdle: false,
        disabled: !enabled || timeoutMs <= 0,
    });


    return { reset };
};

export default useCustomIdleTimer;